module.exports = __webpack_public_path__ + "static/media/FSElliotPro.162e8287.ttf";